import { render, staticRenderFns } from "./familyproducts.vue?vue&type=template&id=6ad821de&"
import script from "./familyproducts.vue?vue&type=script&lang=js&"
export * from "./familyproducts.vue?vue&type=script&lang=js&"
import style0 from "./familyproducts.vue?vue&type=style&index=0&id=6ad821de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports